import axios from 'axios';

const baseURL = process.env.REACT_APP_SERVER_URL;

const server = axios.create({
  baseURL,
});

server.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default server;
